import React from "react";

import { EmptyState, Text } from "@performyard/py-components";
import { EmployeeSummary } from "@performyard/service-contracts";

import { StatCard } from "../components/StatCard";
import { CompetencyRadar } from "./CompetencyRadar";

type CountTile = {
	key: "meets" | "exceeds" | "below";
	label: string;
};

const COUNT_TILES: ReadonlyArray<CountTile> = [
	{ key: "meets", label: "Meets Expectations" },
	{ key: "exceeds", label: "Exceeds Expectations" },
	{ key: "below", label: "Below Expectations" },
];

export const CompetenciesSection: React.FC<{ summary: EmployeeSummary }> = ({ summary }) => {
	const competencies = summary.competencies;

	if (competencies === null) {
		return (
			<div className="mt-2" data-testid="competencies-empty">
				<EmptyState variant="illustration" option={2} label="Not enough competency data to summarize yet" />
			</div>
		);
	}

	const narrative = summary.section_narratives?.competencies ?? null;

	return (
		<div className="mt-1 flex flex-col gap-2">
			<div className="flex gap-2" data-testid="competencies-counts">
				{COUNT_TILES.map((tile) => (
					<StatCard
						key={tile.key}
						label={tile.label}
						value={competencies.counts[tile.key]}
						testId={`competencies-count-${tile.key}`}
					/>
				))}
			</div>

			{narrative !== null ? (
				<Text size="paragraph-3" color="neutral-9" data-testid="competencies-narrative">
					{narrative}
				</Text>
			) : null}

			{competencies.company_wide.length > 0 || competencies.role.length > 0 ? (
				<div className="grid grid-cols-1 gap-4 md:grid-cols-2" data-testid="competencies-radars">
					{competencies.company_wide.length > 0 ? (
						<CompetencyRadar title="Company-Wide Competencies" axes={competencies.company_wide} />
					) : null}

					{competencies.role.length > 0 ? (
						<CompetencyRadar title="Role Competency" axes={competencies.role} />
					) : null}
				</div>
			) : null}
		</div>
	);
};
